import { useQuery } from '@tanstack/react-query'
import type { ShiftServiceListResponse } from 'backend/types'
import { getShiftServices } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseShiftServicesOptions {
  enabled?: boolean // データ取得を有効化するか（デフォルト: true）
}

/**
 * SHIFTサービス一覧を取得するカスタムフック
 *
 * 案件作成画面でSHIFTのサービスを選択・検索できるようにするため導入。
 * バックエンド側で1時間キャッシュされるため、フロントエンドでも30分間のstaleTimeを設定している。
 */
export function useShiftServices(options: UseShiftServicesOptions = {}) {
  const { enabled = true } = options

  return useQuery<ShiftServiceListResponse, Error>({
    queryKey: queryKeys.shiftServices,
    queryFn: async () => {
      return getShiftServices()
    },
    enabled,
    // キャッシュを長めに設定（バックエンドも1時間キャッシュ）
    staleTime: 1000 * 60 * 30,
  })
}
